import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { ButtonFormType, ItemType } from '../../types/chat.types';
interface AdaptiveCardFormProps {
  card: ButtonFormType;
  handleFormSubmit: (response: any) => void;
}

const AdaptiveCardForm: React.FC<AdaptiveCardFormProps> = ({
  card,
  handleFormSubmit,
}) => {
  const connectionStatus = useSelector(
    (state: RootState) => state.socketConnection.status,
  );
  // const { card, handleCardClick } = props;

  return (
    <div className="m-3">
      <div className="mb-4 mx-3 ">{card.label}</div>
      <div className="flex flex-wrap justify-around gap-3 gap-y-6">
        {card.items.map((item: ItemType, index: number) => {
          switch (item.itemsType) {
            case 'button':
              return (
                <div
                  key={index}
                  className={`w-${item.width} flex justify-center`}
                >
                  <button
                    disabled={connectionStatus !== 'Connected'}
                    onClick={() => handleFormSubmit(item.actionType)}
                    className="ml-2 py-2 px-4 w-4/5 rounded-full bg-primary text-white hover:bg-blue-900 focus:outline-none"
                  >
                    {item.placeHolder}
                  </button>
                </div>
              );
            case 'select':
              return (
                <div key={index} className={`w-${item.width}`}>
                  <select
                    className="block appearance-none w-full bg-white border-2 border-gray-300 hover:border-secondary px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                    name={item.name}
                    onChange={() => {}}
                    disabled={connectionStatus !== 'Connected'}
                  >
                    <option value="">{item.placeHolder}</option>
                    {item.select?.options.map(
                      ({ name, value }: any, index: any) => (
                        <option key={index} value={value}>
                          {name}
                        </option>
                      ),
                    )}
                  </select>
                </div>
              );
              break;
            case 'input':
              return (
                <div key={index} className={`w-${item.width}`}>
                  <input
                    type={item.input?.dataType}
                    placeholder={item.placeHolder}
                    disabled={connectionStatus !== 'Connected'}
                    className="w-full focus:outline-none focus:placeholder-gray-400 text-gray-600 placeholder-gray-600 pl-3 bg-gray-100 border-2 border-gray-200 focus:border-primary rounded-lg py-2"
                  />
                </div>
              );
            default:
              <>Error</>;
              break;
          }
        })}
      </div>
    </div>
  );
};

export default AdaptiveCardForm;
